import environment from '_environments'

export const { keys } = environment
